import script from "./SectionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionModal.vue?vue&type=script&setup=true&lang=ts"

import "./SectionModal.vue?vue&type=style&index=0&id=21f394ca&lang=css"

const __exports__ = script;

export default __exports__